import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../../constants/axiosInstance';
import { PreFormBatchConfiguration } from '../types/BatchConfigType';

const fetchPreFormBatchConfiguration = async (): Promise<PreFormBatchConfiguration> => {
  const { data } = await axiosInstance().post('/batch/getPreformCreateBatchConfiguration');
  return data?.data;
};

export const usePreFormBatchConfiguration = () => {
  const {
    data: preFormBatchConfiguration,
    isLoading: isPreFormBatchConfigurationLoading,
    error: preFormBatchConfigurationError,
    refetch: refetchPreFormBatchConfiguration,
  } = useQuery({
    queryKey: ['preFormBatchConfiguration'],
    queryFn: fetchPreFormBatchConfiguration,
    staleTime: 5 * 60 * 1000,
  });

  return {
    preFormBatchConfiguration,
    isPreFormBatchConfigurationLoading,
    preFormBatchConfigurationError,
    refetchPreFormBatchConfiguration,
  };
};
